export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_08_TSeries_end.7e4307a2.jpg";